module.exports = __webpack_public_path__ + "img/debtPayingAbility6.1d479f57.png";